import { formatDate } from "../formatters";

export default function TicketAttachments({ attachments, onDownload }) {
  return (
    <div className="support-ticket-panel">
      <h3 className="heading-3">Pieces jointes</h3>
      {attachments.length > 0 ? attachments.map((attachment) => (
        <div key={attachment.id} className="support-history-item">
          <div>
            <strong>{attachment.filename}</strong>
            <p>{attachment.content_type} - {(attachment.size / 1024).toFixed(1)} Ko</p>
          </div>
          <div className="support-attachment-actions">
            <small>{formatDate(attachment.uploaded_at)}</small>
            <button type="button" className="btn-secondary" onClick={() => onDownload(attachment)}>
              Telecharger
            </button>
          </div>
        </div>
      )) : <p className="body-small">Aucune piece jointe sur ce ticket.</p>}
    </div>
  );
}
